<h2 mat-dialog-title>Reveal full SSNs</h2>

<mat-dialog-content class="dialog-content">
  <div class="sensitive-warning sensitive-warning--reveal">
    <mat-icon>visibility</mat-icon>
    <div>
      <strong>Full SSNs will be displayed</strong>
      <p>
        Reveal {{ data.reportName }} only when the full value is required for the approved purpose below. Do not copy it into notes, messages, or downloads.
      </p>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="outline">
      <mat-label>Business purpose</mat-label>
      <mat-select formControlName="businessPurposeCode">
        <mat-option value="" disabled>Select a purpose</mat-option>
        @for (purpose of data.businessPurposes; track purpose) {
          <mat-option [value]="purpose.code">{{ purpose.label }}</mat-option>
        }
      </mat-select>
      @if (form.get('businessPurposeCode')?.hasError('required')) {
        <mat-error>Business purpose is required.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Reference type</mat-label>
      <mat-select formControlName="referenceType">
        <mat-option value="" disabled>Select a reference type</mat-option>
        @for (option of referenceTypes; track option) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Reference ID</mat-label>
      <input matInput formControlName="referenceId" autocomplete="off" />
      <mat-hint>Enter the approved identifier. Example: MM-5485.</mat-hint>
      @if (form.get('referenceId')?.hasError('required')) {
        <mat-error>Reference ID is required.</mat-error>
      }
      @if (form.get('referenceId')?.hasError('pattern')) {
        <mat-error>Use letters, numbers, and &#64; . _ : + - only.</mat-error>
      }
    </mat-form-field>

    <mat-checkbox formControlName="revealConfirmed" class="reveal-confirmation">
      I confirm that viewing full SSNs is required for this approved business purpose.
    </mat-checkbox>
    @if (form.get('revealConfirmed')?.touched && form.get('revealConfirmed')?.invalid) {
      <mat-error class="confirmation-error">
        Confirm the business need before revealing full SSNs.
      </mat-error>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-raised-button
    color="warn"
    type="button"
    [disabled]="form.invalid"
    (click)="submit()"
    >
    Reveal full SSNs
  </button>
</mat-dialog-actions>
